import { render } from "./HeroiconsSolidGift.vue?vue&type=template&id=30f8fce0"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidGift.vue"]])

export default __exports__